module.exports = __webpack_public_path__ + "static/media/image_5.e3b258d8.jpg";